<template>
    <div data-v-6ebeef4c>
        <usertop></usertop>
        <div data-v-80514a96="" class="LeftPart el-col el-col-24">
            <div data-v-80514a96="" class="el-card is-never-shadow">
                <div class="el-card__body" style="padding: 16px; text-align: left;">
                    <div data-v-80514a96="" class="G-title">
                        升级VIP
                    </div>
                    <div data-v-80514a96="" class="p3">
                        <div data-v-80514a96="" class="text-dark">
                            第一步，查看会员类型和价格
                        </div>
                        <div data-v-80514a96=""
                            class="el-table el-table--fit el-table--border el-table--enable-row-hover el-table--enable-row-transition"
                            style="margin: auto;">
                            <div class="hidden-columns">
                                <div data-v-80514a96=""></div>
                                <div data-v-80514a96=""></div>
                                <div data-v-80514a96=""></div>
                                <div data-v-80514a96=""></div>
                            </div>
                            <div class="el-table__header-wrapper">
                                <table cellspacing="0" cellpadding="0" border="0" class="el-table__header"
                                    style="width: 704px;">
                                    <colgroup>
                                        <col name="el-table_4_column_15" width="176">
                                        <col name="el-table_4_column_16" width="176">
                                        <col name="el-table_4_column_17" width="176">
                                        <col name="el-table_4_column_18" width="176">
                                        <col name="gutter" width="0">
                                    </colgroup>
                                    <thead class="has-gutter">
                                        <tr class="">
                                            <th colspan="1" rowspan="1" class="el-table_4_column_15     is-leaf">
                                                <div class="cell">类型</div>
                                            </th>
                                            <th colspan="1" rowspan="1" class="el-table_4_column_16     is-leaf">
                                                <div class="cell">价格</div>
                                            </th>
                                            <th colspan="1" rowspan="1" class="el-table_4_column_17     is-leaf">
                                                <div class="cell">查看内容</div>
                                            </th>
                                            <th colspan="1" rowspan="1" class="el-table_4_column_18     is-leaf">
                                                <div class="cell">有效期</div>
                                            </th>
                                            <th class="gutter" style="width: 0px; display: none;"></th>
                                        </tr>
                                    </thead>
                                </table>
                            </div>
                            <div class="el-table__body-wrapper is-scrolling-none">
                                <table cellspacing="0" cellpadding="0" border="0" class="el-table__body"
                                    style="width: 704px;">
                                    <colgroup>
                                        <col name="el-table_4_column_15" width="176">
                                        <col name="el-table_4_column_16" width="176">
                                        <col name="el-table_4_column_17" width="176">
                                        <col name="el-table_4_column_18" width="176">
                                    </colgroup>
                                    <tbody>
                                        <tr v-for="o in uservip" class="el-table__row">
                                            <td rowspan="1" colspan="1" class="el-table_4_column_15  ">
                                                <div class="cell">{{o.type}}</div>
                                            </td>
                                            <td rowspan="1" colspan="1" class="el-table_4_column_16  ">
                                                <div class="cell">{{o.price}}</div>
                                            </td>
                                            <td rowspan="1" colspan="1" class="el-table_4_column_17  ">
                                                <div class="cell">Yes</div>
                                            </td>
                                            <td rowspan="1" colspan="1" class="el-table_4_column_18  ">
                                                <div class="cell">{{o.date}}</div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="el-table__column-resize-proxy" style="display: none;"></div>
                        </div>
                    </div>
                    <div data-v-80514a96="" class="p4">
                        * 升级成VIP会员后在有效期内无需积分浏览全站内容。
                    </div>
                    <div data-v-80514a96="" class="el-tabs el-tabs--card el-tabs--top" style="margin: 5px;">
                        <el-tabs v-model="activeName" type="card">
                            <el-tab-pane label="支付宝" name="tongdaoone">
                                <div data-v-80514a96="" class="text-dark">第二步，点击下方对应金额，进入发卡平台购买卡密</div>
                                <div data-v-80514a96="" class="m2">
                                    <span data-v-80514a96="" style="font-size: 14px;">
                                        <a v-for="o in uservip" :href="o.url" target="_blank"><button data-v-80514a96="" type="button" class="el-button el-button--default is-plain" style="margin: 5px;">
                                            <span>{{o.type}}{{o.price}}</span>
                                        </button></a>
                                    </span>
                                </div>
                                <div data-v-80514a96="" class="p4">* 客服邮箱：{{email}}，如果你在购买和使用中出现任何问题，请发邮件给我们并耐心等待回复，我们将会尽快给你解决。</div>
                                <div data-v-80514a96="" class="text-dark">第三步，在下方输入你购买的卡密，点击立即升级</div>
                                <div style="margin: 0 10px 10px 0;">
                                <input type="text" style="margin-right: 5px;width: 260px;" v-model="kainput" autocomplete="off" placeholder="请输入卡密" class="el-input__inner">
                                <el-button type="primary" @click="kaSubmit">立即升级</el-button>
                                </div>
                                <div data-v-80514a96="" style="font-size: 14px;">提示开通成功，将会为你自动更新会员等级，并且自动为你跳转到会员中心。</div>
                            </el-tab-pane>
                        </el-tabs>
                    </div>
                    <div data-v-80514a96="" class="p4">* 请勿为了发布信息去升级VIP，我们审核信息不会因为VIP会员而区别对待，只和信息本身的质量有关系。</div>
                    <div data-v-80514a96="" class="p4">* 请勿为了信息采集和共享账号去升级VIP，如果你的账号使用频率异常将会被系统自动封号。</div>
                </div>
            </div>
            <div data-v-80514a96="" class="el-card is-never-shadow">
                <div class="el-card__body" style="padding: 16px; text-align: left;">
                    <div data-v-80514a96="" class="G-title">
                        升级帮助
                    </div>
                    <div data-v-80514a96="" class="p3">
                        <div data-v-80514a96="" class="text-dark">
                            充值中碰到问题，升级失败了怎么办？
                        </div>
                        <div data-v-80514a96="" class="p2">
                            请提供你的相关账号以及支付信息，然后发邮件给：{{email}}，我们会尽快给你处理。
                        </div>
                    </div>
                    <div data-v-80514a96="" class="p3">
                        <div data-v-80514a96="" class="text-dark">
                            有事怎么联系客服?
                        </div>
                        <div data-v-80514a96="" class="p2">
                            请提供你的账号以及详细描述你的问题，然后发邮件给：{{email}}，我们会尽快给你处理。
                        </div>
                    </div>
                </div>
            </div>
            <div data-v-80514a96="" class="el-card is-never-shadow">
                <div class="el-card__body" style="padding: 16px; text-align: left;">
                    <div data-v-80514a96="" class="G-title">
                        使用帮助
                    </div>
                    <div data-v-80514a96="" class="p3">
                        <div data-v-80514a96="" class="text-dark">
                            网站的信息都是真的吗?
                        </div>
                        <div data-v-80514a96="" class="p2">
                            本站信息都是全国各地狼友亲自经历后发布的，再由我们网站严格审核后才通过，所以可信度请放心。我们每条信息都有一半已显示出来，特别商家频道，肯定有很多你熟悉的地方，每天那么多的信息更新，我们没有你们想象的那么强大，可以捏造出这么多虚假信息，同时如果你有顾虑，可以尝试给我们贡献内容，获取积分后，你就可以使用积分购买单个信息的联系方式，所以，本站信息是不是真的请你判断，如果你还是认为本站信息是假的，那么请你离开本站。
                        </div>
                    </div>
                    <div data-v-80514a96="" class="p3">
                        <div data-v-80514a96="" class="text-dark">
                            为什么网站有一些信息过时了?
                        </div>
                        <div data-v-80514a96="" class="p2">
                            由于行业的特殊性，如果这条信息发布时间半年多了，过时了也正常，但请放心，本站每日大量更新全国信息，我们也建议你更多关注最新的信息。
                        </div>
                    </div>
                    <div data-v-80514a96="" class="p3">
                        <div data-v-80514a96="" class="text-dark">
                            为什么有些信息的联系方式无效？
                        </div>
                        <div data-v-80514a96="" class="p2">
                            由于行业的特殊性，楼凤小姐或者商家联系方式更换比较频繁，同时如果这条信息被很多狼友浏览和添加，也会导致微信或者QQ联系方式被暂时屏蔽或者直接被封。如果你无法搜索QQ和微信，这个时候请你尝试一下手机联系方式，如果长期没回复或者联系方式失效且无法添加，请关注我们同城的其它最新信息即可，我们每日更新大量全国信息，通过我们的最新信息，总会帮你找到快乐和性福。
                        </div>
                    </div>
                    <div data-v-80514a96="" class="p3">
                        <div data-v-80514a96="" class="text-dark">
                            为什么有些信息的联系方式无效？
                        </div>
                        <div data-v-80514a96="" class="p2">
                            由于行业的特殊性，楼凤小姐或者商家联系方式更换比较频繁，同时如果这条信息被很多狼友浏览和添加，也会导致微信或者QQ联系方式被暂时屏蔽或者直接被封。如果你无法搜索QQ和微信，这个时候请你尝试一下手机联系方式，如果长期没回复或者联系方式失效且无法添加，请关注我们同城的其它最新信息即可，我们每日更新大量全国信息，通过我们的最新信息，总会帮你找到快乐和性福。
                        </div>
                    </div>
                    <div data-v-80514a96="" class="p3">
                        <div data-v-80514a96="" class="text-dark">
                            怎么辨别和鉴定虚假联系方式？骗子有一些显著特征呢?
                        </div>
                        <div data-v-80514a96="" class="p2">
                            当你对联系对方有所顾虑的时候，请您尝试百度一下这个联系方式，进行多方的比对。
                        </div>
                        <div data-v-80514a96="" class="p4">
                            * 凡是要求付定金/保证金等任何提前付费的行为，基本都是骗子。
                        </div>
                        <div data-v-80514a96="" class="p4">
                            * 凡是裸聊或者发视频验证，都是来骗钱的，请勿上当。
                        </div>
                        <div data-v-80514a96="" class="p4">
                            * 凡是是求见面地方在她附近的，基本是黑凤集团。
                        </div>
                        <div data-v-80514a96="" class="p4">
                            * 凡是要求见面地方在交通方便的车站附近的，基本不靠谱。
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div data-v-80514a96="" class="RightPart el-col el-col-24">
            <div data-v-80514a96="" class="el-card is-never-shadow" style="text-align: left;">
                <div class="el-card__body">
                    <div data-v-80514a96="" class="text-dark">
                        你也可以使用积分兑换会员
                    </div>
                    <div data-v-80514a96="" class="m2">你的可用积分：{{prices}}</div>
                    <div data-v-80514a96="" class="m2">积分转换会员</div>
                    <div data-v-80514a96="" class="m2"><span data-v-80514a96="">
                        <span class="el-popover__reference-wrapper"><button data-v-80514a96="" type="button"
                                    class="el-button el-button--default el-button--small is-plain el-popover__reference"
                                    aria-describedby="el-popover-2636" tabindex="0" style="width: 200px;"><span><span
                                            data-v-80514a96=""
                                            style="font-size: 14px;">使用2000积分兑换月度会员</span></span></button></span>
                        </span></div>
                    <div data-v-80514a96="" class="m2"><span data-v-80514a96="">
                            <div role="tooltip" id="el-popover-7355" aria-hidden="true" class="el-popover el-popper"
                                tabindex="0" style="display: none;">
                                <div class="el-popconfirm">
                                    <p class="el-popconfirm__main"><i class="el-popconfirm__icon el-icon-question"
                                            style="color: rgb(255, 153, 0);"></i>
                                        确定要用积分升级VIP吗？
                                    </p>
                                    <div class="el-popconfirm__action"><button type="button"
                                            class="el-button el-button--text el-button--mini"><span>
                                                取消
                                            </span></button><button type="button"
                                            class="el-button el-button--primary el-button--mini"><span>
                                                确定
                                            </span></button></div>
                                </div>
                            </div><span class="el-popover__reference-wrapper"><button data-v-80514a96="" type="button"
                                    class="el-button el-button--default el-button--small is-plain el-popover__reference"
                                    aria-describedby="el-popover-7355" tabindex="0" style="width: 200px;"><span><span
                                            data-v-80514a96=""
                                            style="font-size: 14px;">使用5000积分兑换年度会员</span></span></button></span>
                        </span></div>
                    <div data-v-80514a96="" class="m2"><span data-v-80514a96="">
                            <div role="tooltip" id="el-popover-9208" aria-hidden="true" class="el-popover el-popper"
                                tabindex="0" style="display: none;">
                                <div class="el-popconfirm">
                                    <p class="el-popconfirm__main"><i class="el-popconfirm__icon el-icon-question"
                                            style="color: rgb(255, 153, 0);"></i>
                                        确定要用积分升级VIP吗？
                                    </p>
                                    <div class="el-popconfirm__action"><button type="button"
                                            class="el-button el-button--text el-button--mini"><span>
                                                取消
                                            </span></button><button type="button"
                                            class="el-button el-button--primary el-button--mini"><span>
                                                确定
                                            </span></button></div>
                                </div>
                            </div><span class="el-popover__reference-wrapper"><button data-v-80514a96="" type="button"
                                    class="el-button el-button--default el-button--small is-plain el-popover__reference"
                                    aria-describedby="el-popover-9208" tabindex="0" style="width: 200px;"><span><span
                                            data-v-80514a96=""
                                            style="font-size: 14px;">使用10000积分兑换永久会员</span></span></button></span>
                        </span></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'upgrade',
    data() {
        return {
            activeName:'tongdaoone',
            prices:0,
            email:'',
            uservip:[],

            kainput:'',
        }
    },
    methods:{
        kaSubmit(){

            let kinput = this.kainput

            this.$http.post('/api/kami',{ka:kinput}).then(res=>{

                if(res.data.code==0){

                    this.$message({
                        message: res.data.msg,
                        type: 'error'
                    });

                }else{

                    this.$message({
                        message: res.data.msg,
                        type: 'success',
                        onClose:()=>{
                            window.location.href='usercenter';
                        }
                    });

                }
            })

        }
    },
    mounted() {

        this.$http.get('/api/upgrade').then(res=>{

            this.prices = res.data.price

            this.email = res.data.email

            this.uservip = res.data.uservip

        })
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>


// WEBPACK FOOTER //
// src/components/upgrade.vue